import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Factory } from '../../types/models';
import api from '../../services/api';

const SELECTED_FACTORY_KEY = 'selectedFactoryId';

const readSelectedFactory = (): number | null => {
  try {
    const value = localStorage.getItem(SELECTED_FACTORY_KEY);
    return value ? Number(value) || null : null;
  } catch {
    return null;
  }
};

interface FactoryState {
  factories: Factory[];
  // Genel adminin üst menüden seçtiği fabrika; null = Tüm Fabrikalar
  selectedFactoryId: number | null;
}

const initialState: FactoryState = {
  factories: [],
  selectedFactoryId: readSelectedFactory(),
};

export const fetchFactories = createAsyncThunk('factory/fetchFactories', async () => {
  const response = await api.get<Factory[]>('/factories/');
  return response.data;
});

const factorySlice = createSlice({
  name: 'factory',
  initialState,
  reducers: {
    setSelectedFactory: (state, action: PayloadAction<number | null>) => {
      state.selectedFactoryId = action.payload;
      try {
        if (action.payload) {
          localStorage.setItem(SELECTED_FACTORY_KEY, String(action.payload));
        } else {
          localStorage.removeItem(SELECTED_FACTORY_KEY);
        }
      } catch {
        // Tarayıcı depolaması kapalıysa seçim sadece bu oturumda geçerli olur.
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFactories.fulfilled, (state, action) => {
      state.factories = action.payload;
      // Seçili fabrika artık listede yoksa (pasifleştirildi vb.) seçimi kaldır.
      if (state.selectedFactoryId && !action.payload.some((f) => f.id === state.selectedFactoryId)) {
        state.selectedFactoryId = null;
      }
    });
  },
});

export const { setSelectedFactory } = factorySlice.actions;

export default factorySlice.reducer;
